// extracted by mini-css-extract-plugin
export default {"linkContainer":"CopyLink_linkContainer__oacJx","linkInput":"CopyLink_linkInput__YIa+g","copyButton":"CopyLink_copyButton__5YFh7"};